import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";

import { AuthProvider, CartProvider, PlayerProvider } from "./contexts";
import Navigation from "./components/Navigation";
import MediaPlayer from "./components/MediaPlayer";
import Footer from "./components/Footer";

// Module-level constant so <Toaster> gets a referentially-stable prop
// (avoids re-rendering the toaster subtree on every parent re-render).
const TOASTER_OPTIONS = {
  className: "font-mono-label",
  style: {
    background: "#0a0a0a",
    border: "1px solid #FF4500",
    color: "#fff",
    borderRadius: 0,
  },
};

import HomePage from "./pages/HomePage";
import MusicListPage from "./pages/MusicListPage";
import MusicDetailPage from "./pages/MusicDetailPage";
import VideosPage from "./pages/VideosPage";
import VideoDetailPage from "./pages/VideoDetailPage";
import BooksPage from "./pages/BooksPage";
import BookDetailPage from "./pages/BookDetailPage";
import MerchPage from "./pages/MerchPage";
import ProductDetailPage from "./pages/ProductDetailPage";
import CartPage from "./pages/CartPage";
import CheckoutPage from "./pages/CheckoutPage";
import CheckoutSuccessPage from "./pages/CheckoutSuccessPage";
import TipSuccessPage from "./pages/TipSuccessPage";
import NotFoundPage from "./pages/NotFoundPage";
import OrdersPage from "./pages/OrdersPage";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import CultureConnectPage from "./pages/CultureConnectPage";
import BookingsPage from "./pages/BookingsPage";
import MessagesPage from "./pages/MessagesPage";
import StudioPage from "./pages/StudioPage";
import ArtistProfilePage from "./pages/ArtistProfilePage";
import CulturePassPage from "./pages/CulturePassPage";
import CulturePassSuccessPage from "./pages/CulturePassSuccessPage";
import AdminDashboard from "./pages/AdminDashboard";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import JobsPage from "./pages/JobsPage";
import CultureClubPage from "./pages/CultureClubPage";
import BookmarksPage from "./pages/BookmarksPage";
import { ConfirmProvider } from "./components/ConfirmModal";
import { Toaster } from "sonner";

function App() {
  return (
    <AuthProvider>
      <CartProvider>
        <PlayerProvider>
          <BrowserRouter>
            <div className="min-h-screen flex flex-col">
              <Navigation />
              <main className="flex-1">
                <Routes>
                  <Route path="/" element={<HomePage />} />
                  <Route path="/mixtapes" element={<MusicListPage ctype="mixtapes" />} />
                  <Route path="/mixtapes/:id" element={<MusicDetailPage ctype="mixtapes" />} />
                  <Route path="/singles" element={<MusicListPage ctype="singles" />} />
                  <Route path="/singles/:id" element={<MusicDetailPage ctype="singles" />} />
                  <Route path="/videos" element={<VideosPage />} />
                  <Route path="/videos/:id" element={<VideoDetailPage />} />
                  <Route path="/books" element={<BooksPage />} />
                  <Route path="/books/:id" element={<BookDetailPage />} />
                  <Route path="/merch" element={<MerchPage />} />
                  <Route path="/merch/:id" element={<ProductDetailPage />} />
                  <Route path="/cart" element={<CartPage />} />
                  <Route path="/checkout" element={<CheckoutPage />} />
                  <Route path="/checkout/success" element={<CheckoutSuccessPage />} />
                  <Route path="/tip/success" element={<TipSuccessPage />} />
                  <Route path="/orders" element={<OrdersPage />} />
                  <Route path="/login" element={<LoginPage />} />
                  <Route path="/register" element={<RegisterPage />} />
                  <Route path="/signup" element={<RegisterPage />} />
                  <Route path="/forgot-password" element={<ForgotPasswordPage />} />
                  <Route path="/reset-password" element={<ResetPasswordPage />} />
                  <Route path="/jobs" element={<JobsPage />} />
                  <Route path="/culture-club" element={<CultureClubPage />} />
                  <Route path="/subscribe" element={<CultureClubPage />} />
                  <Route path="/bookmarks" element={<BookmarksPage />} />
                  <Route path="/dashboard" element={<StudioPage />} />
                  <Route path="/creatives" element={<CultureConnectPage defaultType="creative" />} />
                  <Route path="/talent" element={<CultureConnectPage defaultType="talent" />} />
                  <Route path="/education" element={<CultureConnectPage defaultType="education" />} />
                  <Route path="/employers" element={<CultureConnectPage defaultType="employer" />} />
                  <Route path="/culture-connect" element={<CultureConnectPage />} />
                  <Route path="/bookings" element={<BookingsPage />} />
                  <Route path="/messages" element={<MessagesPage />} />
                  <Route path="/studio" element={<StudioPage />} />
                  <Route path="/culture-pass" element={<CulturePassPage />} />
                  <Route path="/culture-pass/success" element={<CulturePassSuccessPage />} />
                  <Route path="/artist/:username" element={<ArtistProfilePage />} />
                  <Route path="/profile/:username" element={<ArtistProfilePage />} />
                  <Route path="/admin" element={<AdminDashboard />} />
                  <Route path="*" element={<NotFoundPage />} />
                </Routes>
              </main>
              <Footer />
              <MediaPlayer />
              <ConfirmProvider />
              <Toaster
                theme="dark"
                position="top-right"
                richColors
                closeButton
                toastOptions={TOASTER_OPTIONS}
              />
            </div>
          </BrowserRouter>
        </PlayerProvider>
      </CartProvider>
    </AuthProvider>
  );
}

export default App;
